var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".progress-icons"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1115",
    cx: 8,
    cy: 8.5,
    r: 6.6,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.177 6.92701L7.17701 10.927C7.1538 10.9503 7.12622 10.9687 7.09587 10.9813C7.06552 10.9939 7.03299 11.0003 7.00014 11.0003C6.96729 11.0003 6.93475 10.9939 6.9044 10.9813C6.87405 10.9687 6.84648 10.9503 6.82326 10.927L5.07326 9.17701C5.02635 9.1301 5 9.06648 5 9.00014C5 8.9338 5.02635 8.87017 5.07326 8.82326C5.12017 8.77635 5.1838 8.75 5.25014 8.75C5.31648 8.75 5.3801 8.77635 5.42701 8.82326L7.00014 10.3967L10.8233 6.57326C10.8702 6.52635 10.9338 6.5 11.0001 6.5C11.0665 6.5 11.1301 6.52635 11.177 6.57326C11.2239 6.62017 11.2503 6.6838 11.2503 6.75014C11.2503 6.81648 11.2239 6.8801 11.177 6.92701Z",
    fill: "#7D0000",
    stroke: "#7D0000",
    strokeWidth: 0.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.b0b4ea7c617dadb5b886144693c4a82a.svg";
export { ForwardRef as ReactComponent };